<template>
  <div v-show="active === ruleForm.status">
    <el-dialog title="VNDA" :visible.sync="dialog" :width="'70%'">
      <el-form :model="ruleForm">
        <el-form-item label="Nome">
          <el-input v-model="ruleForm.configuration.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Base URL">
          <el-input v-model="ruleForm.configuration.baseUrl"></el-input>
        </el-form-item>
        <el-form-item label="Url Loja">
          <el-input v-model="ruleForm.configuration.store"></el-input>
        </el-form-item>
        <el-form-item label="Token">
          <el-input v-model="ruleForm.configuration.token"></el-input>
        </el-form-item>
        <el-row style="padding-top: 10px;">
          <el-col>
            <el-checkbox v-model="ruleForm.configuration.useValue"
              :checked="ruleForm.configuration.useValue == 'S' ? true : false">
              Usar valor da NF como valor declarado
            </el-checkbox>
          </el-col>
        </el-row>
        <el-form-item label="Webhook">
          <el-input disabled v-model="endpoint"></el-input>
        </el-form-item>
        <el-row style="padding-top: 15px;">
          <el-col>
            <span style="font-weight: bold;">Serviços Disponíveis</span>
          </el-col>
          <div class="table-services">
            <div style="display: flex;">
              <div class="services-table-header">
                <span>Código</span>
                <span>Nome original do Serviço</span>
              </div>
              <div class="services-table-header">
                <span>Nome utilizado na Integradora</span>
              </div>
            </div>
            <el-row class="services-body" v-for="item of customerServices" :key="item.serviceCode">
              <el-checkbox @change="selectService(item)" v-model="item.selected" style="margin-right: 3px;"></el-checkbox>
              <el-input class="service-code" disabled v-model="item.serviceCode"></el-input>
              <el-input class="service-name" disabled v-model="item.serviceOriginalName"></el-input>
              <el-input class="service-new-name" v-model="item.newName"></el-input>
            </el-row>
          </div>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" v-if="ruleForm.id" @click="remove()">Desativar integração</el-button>
        <el-button @click="dialog = false">Voltar</el-button>
        <el-button type="primary" @click="validate()">Validar credenciais</el-button>
        <el-button type="success" @click="save()">Salvar</el-button>
      </span>
    </el-dialog>
    <IntegrationCard image="/img/integration/logo-vnda.svg" title="Vnda"
      :status="ruleForm.status" :updatedAt="ruleForm.updatedAt" :options="ruleForm.options" :id="ruleForm.id"
      @configure="configure" />

  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { IntegrationService } from "@/services/customers/integration.services";
import { CustomerService } from "@/services/customers/customers.services";
import IntegrationCard from "../components/IntegrationCard.vue";

export default {
  name: "Integration",
  props: ["customer", "active"],
  methods: {
    setConfig(config) {
      console.log(config)
      const vm = this;
      vm.endpoint = `https://portalmaisenvios.com.br/webhooks/integrations/vnda/${vm.customer}`;
      vm.ruleForm.configuration = config.configuration
      vm.ruleForm.id = config.id;
      vm.ruleForm.status = config.status;
      vm.ruleForm.updatedAt = config.updatedAt;
      if (vm.customer) this.getCustomerData(vm.customer)
    },
    configure() {
      const vm = this;
      vm.endpoint = `https://portalmaisenvios.com.br/webhooks/integrations/vnda/${vm.customer}`;
      if (vm.customer) this.getCustomerData(vm.customer)
      vm.dialog = true;
    },
    selectService(value) {
      this.servicesSelected.push(value)
    },

    filterServices(value) {
      const vm = this;

      const itemIndex = vm.ruleForm.configuration['service-code'].findIndex(i => i == value)

      if (itemIndex !== -1) {
        vm.ruleForm.configuration['service-code'].splice(itemIndex, 1);
        vm.ruleForm.configuration['service-new-name'].splice(itemIndex, 1)
      }
    },

    getCustomerData(customerId) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      CustomerService.get(customerId).then(response => {
        const config = vm.ruleForm.configuration;
        const servicesData = response.service ? response.service.map((item) => {
          const configData = config.service && config.service.length > 0 
            ? config.service.find(x => x.code === item.code)
            : null
          return {
            serviceCode: item.code,
            serviceOriginalName: item.name,
            newName: configData ? configData.name : "",
            selected: configData ? true : false,
        }
        }) : []

        const filteredServiceData = config.services
          ? servicesData.filter(item => !config['service-code']
            .includes(item.serviceCode))
          : servicesData

        vm.customerServices = filteredServiceData
      })
        .catch(error => console.log(error))
        .finally(() => loading.close());
    },

    reset() {
      const vm = this;
      vm.ruleForm = {
        status: false,
        options: [],
        configuration: {
          name: "",
          baseUrl: "https://api.vnda.com.br",
          token: "",
          useValue: false,
          service: {
            code: [],
            name: [],
          }
        },
        updatedAt: "Sem registros"
      };
    },

    validate() {
      var vm = this;
      const config = vm.ruleForm.configuration;
      const loading = vm.$loading(vm.$options.loading);
      IntegrationService.validateCredentials({
        type: "vnda",
        configuration: JSON.stringify(vm.ruleForm.configuration),
        customer: vm.customer
      }).then((response) => {
        console.log(response)
        this.$message({
          type: "success",
          message: i18n.tc("credenciais-validadas-sucesso"),
        });
      }).catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      }).finally(() => loading.close());
    },

    save() {
      var vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const { configuration } = vm.ruleForm;

      configuration.service = vm.customerServices.filter(x => x.selected).map(x => {
        return {
          code: x.serviceCode,
          name: x.newName,
        }
      })

      console.log('vm.ruleForm', vm.ruleForm, configuration);

      if (vm.ruleForm.id) {
        IntegrationService.update(
          vm.ruleForm.id,
          {
            type: "19",
            configuration: configuration,
            customer: vm.customer
          }
        )
          .then((response) => {
            setTimeout(() => {
              vm.$emit("refresh");
            }, 300);
            vm.dialog = false;
            this.$message({
              type: "success",
              message: i18n.tc("integracao-adicionado-sucesso"),
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      }
      else {
        IntegrationService.add({
          type: "19",
          configuration: configuration,
          customer: vm.customer
        })
          .then((response) => {
            setTimeout(() => {
              vm.$emit("refresh");
            }, 300);
            vm.dialog = false;
            this.$message({
              type: "success",
              message: i18n.tc("integracao-adicionado-sucesso"),
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      }
    },
    logs: function () {
      const vm = this;
      this.$router.push({
        name: "integration.logs",
        params: { id: vm.ruleForm.id },
      });
    },
    remove: function (id, name) {
      const vm = this;
      this.$confirm(i18n.t("confirmar-eliminacao-integracao", { id: "VNDA" }),
        i18n.tc("aviso"), {
        confirmButtonText: "OK",
        cancelButtonText: i18n.tc("cancelar"),
        type: i18n.tc("aviso"),
        center: true,
      }).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        IntegrationService.unregister({ customer: vm.customer, type: "19" })
          .then((response) => {
            setTimeout(() => {
              vm.$emit("refresh");
              vm.dialog = false;
            }, 300);
            this.$message({
              type: "success",
              message: i18n.tc("integracao-eliminado-sucesso"),
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
  },
  data() {
    return {
      ruleForm: {
        id: "",
        status: false,
        options: [],
        configuration: {
          name: "",
          baseUrl: "https://api.vnda.com.br",
          token: "",
          store: "",
          useValue: false,
          service: {
            code: [],
            name: [],
          },
        },
        updatedAt: "Sem registros"
      },
      dialog: false,
      customerServices: undefined,
      servicesSelected: []
    };
  },
  components: { IntegrationCard }
};
</script>
